export enum TASK_PRIORITY {
  "URGENT-IMPORTANT" = 1,
  "URGENT-NOT IMPORTANT",
  "IMPORTANT-NOT URGENT",
  "NOT IMPORTANT-NOT URGENT"
}
